import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRefreshTokenReducer from '../reducers/refresh-token.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

export const getRefreshTokenState = createSelector(getAuthState, state => state[fromRefreshTokenReducer.refreshTokenFeatureKey]);

export const getRefreshTokenResponse = createSelector(getRefreshTokenState, fromRefreshTokenReducer.refreshTokenResponse);
